<div *ngIf="notifyiterationList && notifyiterationList.length > 0">
  <div
    class="sectpad container mbwidth p-0"
    *ngFor="let notification of notifyiterationList"
  >
    <button
      type="button"
      class="close videoclose outline"
      (click)="closenotification(notification, 'close')"
    ></button>
    <div class="col-12 d-flex p-0">
      <div
        class="col-5 col-md-4 col-lg-2 text-left pl-3 pr-0 font-weight-bold-calibre cirprog"
        *ngIf="notification.title.includes('Congratulations') === false"
      >
        <circle-progress
          [percent]="notification.questionnairePercent"
          [radius]="circleRadius"
          [outerStrokeWidth]="8"
          [innerStrokeWidth]="8"
          [outerStrokeColor]="'#ED1976'"
          [innerStrokeColor]="'#cccccc'"
          [animation]="true"
          [animationDuration]="300"
          [space]="-10"
          [titleFontSize]="circleTitleFontSize"
          
          [titleColor]="'#2B2E34'"
          [unitsFontSize]="circleUnitsFontSize"
          
          [unitsColor]="'#2B2E34'"
          [showSubtitle]="true"
          [subtitle]="profile"
          [subtitleFontSize]="subTitleFont"
          [subtitleColor]="'#777777'"
          [subtitleFontWeight]="fontWieght"
        ></circle-progress>
      </div>
      <div
        class="col-5 col-md-4 col-lg-4 text-left pl-3 pr-0 cirprog"
        *ngIf="notification.title.includes('Congratulations')"
      >
        <img class="congimgwdt" src="assets/images/success.png" />
      </div>
      <div
        class="col-5 col-md-4 col-lg-4 text-left pl-3 pr-0 cirprog"
        *ngIf="notification.type === 'renewal'"
      >
        <img class="congimgwdt" src="assets/images/renewimg.svg" />
      </div>
      <div
        class="col-7 col-md-8 col-lg-8 pr-1 pb-3 notifycontent"
        *ngIf="!notification.title.includes('One phone')"
      >
        <p
          class="notidet semi-bold pikclr mt-3 mb-0"
          *ngIf="!notification.title.includes('One phone')"
        >
          {{ notification.title }}
        </p>
        <p
          class="notidet semi-bold pikclr mt-3 mb-0"
          *ngIf="
            notification.title === 'One phone call, that’s all!' ||
            notification.title === 'One phone call, that�s all!'
          "
        >
          One phone call, that’s all!
        </p>
        <div
          class="notidet font-weight-normal-calibre"
          *ngIf="!notification.title.includes('One phone')"
        >
          <div *ngIf="notification.title.includes('One phone')">
            Complete the signup process for
            <div style="display: inline-block">
              {{ notification.userAddress }}
            </div>
            by pressing
            <span class="fntbold clrblue">
              <div style="display: inline-block">
                <a
                  [href]="'tel:' + '1-855-780-5209'"
                  style="color: #1f0bcc !important"
                  >1-855-780-5209</a
                >
              </div>
            </span>
            and reference your Customer ID
            <div style="display: inline-block">
              ({{ notification.order_no }})
            </div>
          </div>
          <p
            class="notidet font-weight-normal-calibre"
            *ngIf="!notification.title.includes('One phone')"
            [innerHTML]="notification.message"
          >
            {{ notification.message }}
          </p>

          <a
            class="webview btn sectbtn notibtn semi-bold mb-3 mt-3"
            style="text-transform: uppercase !important"
            href="javascript:void(0)"
            *ngIf="notification.buttonName"
            (click)="completeProcess(notification)"
            >{{ notification.buttonName }}</a
          >

          <a
            class="mobileview btn sectbtn notibtn semi-bold mb-3 mt-3"
            style="text-transform: uppercase !important"
            href="javascript:void(0)"
            *ngIf="notification.buttonName"
            (click)="completeProcess(notification)"
            >{{ notification.buttonName }}</a
          >
        </div>
        <div
          class="webview"
          *ngIf="notification.type === 'pending_verification'"
        >
          <a
            class="mobileview btn sectbtn notibtn semi-bold mb-3 mt-3"
            style="text-transform: uppercase !important"
            href="javascript:void(0)"
            *ngIf="notification.buttonName"
            (click)="completeProcess(notification)"
            >{{ notification.buttonName }}</a
          >
        </div>
        <div
          class="webview"
          *ngIf="
            !notification.title.includes('One phone') &&
            !notification.title.includes('Congratulations!')
          "
        >
          <a class="{{notification.buttonName == 'Shop Now' ? 'marginforstartover_4' : 'marginforstartover_8'}}"
            style="
              color: #007bff !important;
              font-size: 16px;
              cursor: pointer;
              text-align: center;
              line-height: 0px;
            "
            (click)="startOverforheader()"
            >Start Over</a>
        </div>
        <div
        class="mobileview"
        *ngIf="
          !notification.title.includes('One phone') &&
          !notification.title.includes('Congratulations!')
        "
      >
        <a
          style="
            margin-left: 35%;
            color: #007bff !important;
            font-size: 16px;
            cursor: pointer;
            text-align: center;
            line-height: 0px;
          "
          (click)="startOverforheader()"
          >Start Over</a
        >
      </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</div>

<div  *ngIf="
notifyiterationList &&
notifyiterationList.length === 1 &&
notifyiterationList[0].title == 'Congratulations!'
" class="col-12 text-center mb-4 mt-4">
  <div
   
  >
    <div class="sectpad container mbwidth p-0">
      <p class="notidet font-weight-normal-calibre">
        Have a rental, vacation or lake house that you need an energy plan for?
      </p>
    </div>
  </div>
</div>
